const inputNormalizer = (value, name, callback) => {
  const e = {
    target: {
      name: name,
      value: value
    }
  }
  callback(e)
}

export { inputNormalizer }